export default __webpack_public_path__ + "static/drivethru_1-a30e6c85673ca24d4bb99304898bf91f.png";